import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../core/api/module';
import { Endpoints } from '../../core/api/endpoints';
import { Language } from '../../localization/models';


const KEY_ACTION = ActionType.ProjectLanguagesRequest;
const ACTIONS    = [
  ActionType.ProjectLanguagesRequest,
  ActionType.ProjectLanguagesResponse,
  ActionType.ProjectLanguagesError,
];


type Payload = Language[];

type Meta = {
  projectId: number;
};


/**
 * Dispatch this action to load the translations for the given language from the internet
 */
export const projectLanguagesAction = (projectId: number) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.ProjectLanguages,
  headers:  { 'content-type': 'application/json' },
  body:     JSON.stringify({ projectId: projectId }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId: projectId }),
  bailout:  state => !!getLoading(state, KEY_ACTION, projectId),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, action.meta.projectId);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, action.meta.projectId);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, action.meta.projectId);

  return R.assocPath(['projectLanguages', `${action.meta.projectId}`], payload, successState);
};


export const projectLanguagesReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
